module.exports = __webpack_public_path__ + "static/media/Bertie-Gilbert-Filmmaking-and-Directing.4a7e89b6.jpg";